import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL, LabelM } from '@sorare/core/src/atoms/typography';

import { ManagerProgressionMissionContentTile } from 'components/rivals/RivalsTile/ManagerProgressionMissionContentTile';

import { DailyClaim_footballRivalsCurrentManager } from './__generated__/index.graphql';

const Root = styled(Vertical).attrs({ gap: 3 })`
  padding: var(--double-unit);
`;

type Props = {
  currentManager: DailyClaim_footballRivalsCurrentManager;
};
export const DailyClaim = ({ currentManager }: Props) => {
  const { buyCardMission } = currentManager;

  if (!buyCardMission) {
    return null;
  }

  return (
    <Root className="text-center">
      <Vertical gap={0.5} center>
        <HeadlineL as="h2">
          <FormattedMessage
            id="ClaimArenaTicket.dailyClaim.title"
            defaultMessage="Need more Arena tickets?"
          />
        </HeadlineL>
        <LabelM as="span" color="var(--c-neutral-600)">
          <FormattedMessage
            id="ClaimArenaTicket.dailyClaim.description2"
            defaultMessage="Complete the daily mission:"
          />
        </LabelM>
      </Vertical>
      <ManagerProgressionMissionContentTile tile={buyCardMission} />
    </Root>
  );
};

DailyClaim.fragments = {
  footballRivalsCurrentManager: gql`
    fragment DailyClaim_footballRivalsCurrentManager on FootballRivalsCurrentManager {
      id
      buyCardMission {
        id
        ...ManagerProgressionMissionContentTile_managerProgressionMissionContentTile
      }
    }
    ${ManagerProgressionMissionContentTile.fragments
      .managerProgressionMissionContentTile}
  ` as TypedDocumentNode<DailyClaim_footballRivalsCurrentManager>,
};
